<template>
    <v-card>
        <v-card-title>
            {{$t('event.evoucher')}}
            <v-spacer></v-spacer>
            <v-btn class="mr-3" :disabled="!selectedEvouchers.length" :dark="!!selectedEvouchers.length" color="red" @click="deleteEvoucher">
                Delete Selected ({{selectedEvouchers.length}})
            </v-btn>
            <v-btn color="primary" @click="$router.push({name: 'evoucher-guests-batch-add'})">
                {{$t('evoucher.add')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col>
                    <v-select clearable
                              :label="$t('Merchant')"
                              :placeholder="$t('Merchant')"
                              :items="merchantOptions"
                              v-model="merchantFilter">
                    </v-select>
                </v-col>
                <!-- <v-col>
                    <v-select clearable
                              :label="$t('Guest')"
                              :placeholder="$t('Guest')"
                              :items="guestOptions"
                              v-model="guestFilter">
                    </v-select>
                </v-col> -->
                <v-col>
                    <v-text-field v-model="search"
                                  append-icon="mdi-magnify"
                                  :label="$t('search')"
                                  single-line
                                  hide-details
                                  clearable>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-data-table :headers="headers"
                          :items="objectList"
                          :loading="isEventEvoucherPending"
                          :search="search"
                          show-select
                          v-model="selectedEvouchers"
                          no-data-text="No Evouchers"
                          :footer-props="{
                            'items-per-page-options': [10, 50, 100, 500, -1]
                          }"
                          >
                <template v-slot:item.createdAt="{value}">
                    {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
                </template>
                <template v-slot:item.is_used="{value}">
                    {{(value) ? value = 'Used' : value = '-'}}
                </template>
                <template v-slot:item.is_disabled="{value}">
                    {{(value) ? value = 'Disabled' : value = '-'}}
                </template>
                <template v-slot:item.actions="{item}">
                    <v-btn color="primary"
                    :to="{name: 'evoucher-guests-edit', params: {evoucherGuestsId: item.id}}">
                        {{$t('edit')}}
                        <v-icon right>mdi-pencil</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
        
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        
        <v-dialog v-model="dialog" scrollable max-width="640px">
            <v-card>
                <v-card-text style="height: 360px; padding: 15px" v-html="dialogMsg">
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <RouterView></RouterView>
    </v-card>
</template>

<script>
    import {computed, ref} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";

    export default {
        name: 'EventEvoucherGuestsList',
        setup(props, {root}) {
            const {EvoucherGuest} = root.$FeathersVuex.api;

            const eventId = computed(() => root.$route.params.eventId);
            
            const overlay = ref(false);
            const dialog = ref(false);
            const dialogMsg = ref('');
            const selectedEvouchers = ref([]);
            const merchantFilter = ref('');
            const guestFilter = ref('');
            
            const evoucherParams = computed(() => {
                let params = {
                    query: {
                        eventId: eventId.value,
                        $sort: {
                            createdAt: -1,
                        }
                    }
                };
                return params;
            });
            const {items: eventEvouchers, isPending: isEventEvoucherPending} = useFind({
                model: EvoucherGuest,
                params: evoucherParams
            });

            // Data Table
            const headers = ref([
                {text: root.$t('Merchant Email'), value: 'merchants.email'},
                {text: root.$t('Merchant Name'), value: 'merchants.firstname'},
                {text: root.$t('Guest Email'), value: 'event_guests.ev_email'},
                {text: root.$t('Guest Name'), value: 'event_guests.ev_firstname'},
                {text: root.$t('Day'), value: 'day'},
                {text: root.$t('Location'), value: 'location'},
                {text: root.$t('Used'), value: 'is_used'},
                {text: root.$t('Disabled'), value: 'is_disabled'},
                {text: root.$t('Created At'), value: 'createdAt'},
                {text: '', value: 'actions', filterable: false, width: '120', align: 'end'},
            ]);
            
            const deleteEvoucher = async () => {
                if (confirm(root.$t('evoucher.confirm_delete'))) {
                    overlay.value = true;
                    let count = 0;
                    let errorCount = 0;
                    let errorMsg = '';
                
                    let i = selectedEvouchers.value.length;
                    while (i--) {
                        let temp = await selectedEvouchers.value[i].remove().then(() => {
                            selectedEvouchers.value.splice(i, 1);
                            return false;
                        }, (e) => {
                            return e.errors ? e.errors.map ? (e.errors.map(a => a.message)).join('; ') : e.message : e.statusText;
                        });
                        count++;
                        if (temp) {
                            errorMsg = '<li>' + temp + '</li>' + errorMsg;
                            errorCount++;
                        }
                    }
                
                    overlay.value = false;
                    if (errorCount) {
                        dialogMsg.value = (count - errorCount) + ' of ' + count + ' Evoucher(s) sucessfully deleted.<br><br>' + (errorCount) + ' of ' + count + ' Evoucher(s) NOT deleted:<br><ul>' + errorMsg + '</ul>';
                        dialog.value = true;
                    } else {
                        dialogMsg.value = '';
                        root.$store.dispatch('showSnackBar', count + ' Evoucher(s) Deleted.' + errorMsg);
                    }
                }
            };

            const merchantOptions = computed(() => {
                return eventEvouchers.value.map(v => {
                    let text;
                    let value;
                    if (!v.merchants) {
                        text = "-";
                        value = "-";
                    } else {
                        text = v.merchants.firstname;
                        value = v.merchants.id;
                    }
                    return {
                        text: text,
                        value: value
                    }
                });
            });

            const guestOptions = computed(() => {
                return eventEvouchers.value.map(v => {
                    let text;
                    let value;
                    if (!v.event_guests) {
                        text = "-";
                        value = "-";
                    } else {
                        text = v.event_guests.ev_firstname;
                        value = v.event_guests.id;
                    }
                    return {
                        text: text,
                        value: value
                    }
                });
            });

            const objectList = computed(() => {
                let list = [...eventEvouchers.value];
                list.forEach((v) => {
                    if (v.merchants === null) {
                        v.merchants = {
                            'firstname': '-',
                            'id': '-',
                            'email': '-'
                        };
                    }
                })
                if (merchantFilter.value) {
                    list = list.filter(v => {
                        return v.merchants.id === merchantFilter.value;
                    });
                }
                if (guestFilter.value) {
                    list = list.filter(v => {
                        return v.event_guests.id === guestFilter.value;
                    });
                }
                return list;
            })

            return {
                selectedEvouchers,
                deleteEvoucher,
                overlay,
                dialog,
                dialogMsg,

                isEventEvoucherPending,
                eventEvouchers,

                headers,
                search: ref(''),
                DateTime,

                merchantOptions,
                guestOptions,
                merchantFilter,
                guestFilter,
                objectList
            }
        }
    }
</script>
